import React from "react"
import { Box, IconButton } from "@mui/material"

import { makeStyles } from "makeStyles"

import Icon from "@mdi/react"
import { mdiHeartOutline } from "@mdi/js"

import Price from "components/Price"
import Button from "components/Buttons/Button"
import ChangeAmountButton from "components/Buttons/ChangeAmountButton"

import useScrollPosition from "@secureo/common/hooks/useScrollPosition"

type FloatingPriceVariant = "configuration" | "sticky-nav"

const useStyles = makeStyles()({
	floatPriceByConfiguration: {
		position: "fixed",
		top: 10,
		width: 280,
		background: "#263739",
		borderRadius: 5,
		zIndex: 0,
		left: -380,
		display: "block",
		// TODO: make alignment more responsive (find better solution)
		"@media only screen and (min-width: 960px) and (max-width: 1730px)": {
			left: -320,
			width: 280,
			display: "block",
		},
		"@media only screen and (max-width: 960px)": {
			display: "none",
		},
	},
	floatPriceBelowStickyNav: {
		position: "fixed",
		top: 100,
		width: 230,
		background: "#263739",
		borderRadius: 5,
		zIndex: 0,
		right: -325,
		display: "block",
		// TODO: make alignment more responsive (find better solution)
		"@media only screen and (min-width: 1260px) and (max-width: 1730px)": {
			right: -320,
			display: "block",
		},
		"@media only screen and (max-width: 1260px)": {
			display: "none",
		},
	},
	wishlistAndCompareButton: {
		background: "white",
		border: "1px solid white",
		boxShadow: "none",
		color: "#4691CE",
		marginLeft: 7,
		height: 43,
		width: 43,
		"&:hover": {
			border: "1px solid #4691CE",
			background: "#4691CE",
			color: "white",
		},
	},
	displayNone: {
		display: "none",
	},
	slideInTop: {
		animation: "$slideInTopEffect 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) both",
	},
	"@keyframes slideInTopEffect": {
		"0%": {
			transform: "translateY(-200px)",
			opacity: 0,
		},
		"100%": {
			transform: "translateY(0)",
			opacity: 1,
		},
	},
})

const getFloatingPriceClassName = (
	classes: {
		floatPriceByConfiguration: string
		floatPriceBelowStickyNav: string
	},
	variant: FloatingPriceVariant,
) => {
	switch (variant) {
		case "configuration":
			return classes.floatPriceByConfiguration
		case "sticky-nav":
			return classes.floatPriceBelowStickyNav
		default:
			return classes.floatPriceBelowStickyNav
	}
}

const FloatingPrice = ({
	singleGrossPriceCents,
	singleGrossMsrpPriceCents,
	addToCart,
	quantity,
	setQuantity,
	addToShoppingList,
	isLoading,
	variant,
}: Props) => {
	const { classes } = useStyles()

	const { scrollY } = useScrollPosition()

	const className = getFloatingPriceClassName(classes, variant)

	return (
		<div className={scrollY > 100 ? "" : classes.displayNone}>
			<div className={classes.slideInTop}>
				<Box p={1} py={2} className={className}>
					<Box mx={2} style={{ fontSize: 14, color: "white", textAlign: "left" }}>
						Statt:{" "}
						<span style={{ textDecoration: "line-through" }}>
							<Price priceInEuroCents={singleGrossMsrpPriceCents} />
						</span>
					</Box>
					<Box
						mx={2}
						mt={-1}
						style={{ display: "flex", alignItems: "center", color: "white" }}
					>
						<strong style={{ fontSize: 25 }}>
							<Price priceInEuroCents={singleGrossPriceCents} />
						</strong>
						<Box ml={1} style={{ fontSize: 12 }}>
							inkl. MwSt.
						</Box>
					</Box>
					<Box mt={1} style={{ display: "flex", alignItems: "center" }}>
						<Box ml={1} style={{ background: "white", borderRadius: 20 }}>
							<ChangeAmountButton
								quantity={quantity}
								onChange={setQuantity}
								minQuantity={1}
							/>
						</Box>
						<IconButton
							color="secondary"
							aria-label="add-to-wish-list"
							size="small"
							className={classes.wishlistAndCompareButton}
							onClick={addToShoppingList}
						>
							<Icon path={mdiHeartOutline} size={1.7} />
						</IconButton>
					</Box>
					{
						<Box mx={1} mt={2} pr={2} style={{ width: "95%" }}>
							<Button color="primary" onClick={addToCart} disabled={isLoading}>
								<Box mr={1}>In den Warenkorb </Box>
							</Button>
						</Box>
					}
				</Box>
			</div>
		</div>
	)
}

interface Props {
	singleGrossPriceCents: number
	singleGrossMsrpPriceCents: number
	setQuantity: (quantity: number) => void
	addToCart: () => void
	addToShoppingList: () => void
	isLoading: boolean
	quantity: number
	variant?: FloatingPriceVariant
	manufacturer: string
}

export default FloatingPrice
